import { useEffect, useMemo, useRef } from 'react'
import { useFloorPlanState } from '../../../../../../../../../stateProviders/FloorPlanStateProvider';
import { useWallState } from '../../../../../../../../../stateProviders/WallStateProvider';

export const ClickableLine:React.FC<{
    setWallActive: React.Dispatch<React.SetStateAction<boolean>>
    setWallClick: React.Dispatch<React.SetStateAction<{ wallClickX: number; wallClickY: number; }>>
}> = ({ setWallActive, setWallClick }) => {

    const clickableLineRef = useRef<SVGLineElement>(null)
    const floorPlanState = useFloorPlanState()
    const wallState = useWallState();

    //scale the thickness of the line based on the zoom level
    const strokeWidth = useMemo( () => {
        return 10 / floorPlanState.zoomLevel
    },[floorPlanState.zoomLevel]);

    useEffect( () => {
        // add click listener that sets wallActive to false if not clicked
        const lineClickListener = (e:MouseEvent) => {
            if(clickableLineRef.current && !clickableLineRef.current.contains(e.target as Node)){
                setWallActive(false)
            }
        }
        document.addEventListener('click', lineClickListener)
        return () => {
            document.removeEventListener('click', lineClickListener)
        }
    },[clickableLineRef.current])

    return (<>
        <line 
            style={{strokeWidth}}
            ref={clickableLineRef}
            onClick={(e) => {
                if(floorPlanState.drawingShape) return
                // Set the coordinates of the click, converts to the drawspace coordinates from window coordinates
                const x = (e.pageX - floorPlanState.drawspaceBoundingRect.left - floorPlanState.panOffset.x) / floorPlanState.zoomLevel;
                const y = (e.pageY - floorPlanState.drawspaceBoundingRect.top - floorPlanState.panOffset.y) / floorPlanState.zoomLevel;
                setWallActive(true)
                setWallClick({wallClickX:x, wallClickY:y})
                
            }}
            className='relative z-[0] stroke-transparent cursor-pointer hover:stroke-black' 
            x1={wallState.x1} 
            y1={wallState.y1} 
            x2={wallState.x2} 
            y2={wallState.y2} 
        />
    </>)
}